<footer class="pb-70" style="height: 500px;">
    <!-- <div class="newsletter-area">
        <div class="container">
            <div class="row newsletter-wrap align-items-center">
                <div class="col-lg-6">
                    <div class="newsletter-item">
                        <h2>{{'COMMON.NEWSLETTER' | translate}}</h2>
                        <p>{{'COMMON.NEWSLETTERPARA' | translate}}</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="newsletter-item">
                        <div class="newsletter-form">
                            <form class="newsletter-form">
                                <input type="email" class="form-control" placeholder="{{'CONTACTUS.EMAIL' | translate}}" name="EMAIL">
                                <button class="btn newsletter-btn" type="submit">{{'COMMON.SUBSCRIBE' |
                                    translate}}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="container" style="margin-top: -100px;">
        <div class="row">
            <div class="col-lg-3" *ngIf="language == 'ar'"></div>
            <div class="col-sm-6 col-lg-6 " style="color: rgb(182 142 39) !important;">
                <div class="footer-item">
                    <div class="footer-contact">
                        <h3>{{'CONTACTUS.CONTACTUS' | translate}}</h3>
                        <ul>
                            <li>
                                <!-- <i class="icofont-ui-message"></i> -->
                                <a href="#" style="margin-right: -45px;margin-left: -30px;">{{ HospitalContacts?.email }}</a>
                                <!-- <a href="mailto:hello@opvix.com">hello@opvix.com</a> -->
                            </li>
                            <!-- <li style="font-size: 18px !important;direction: ltr !important;"><a href=""><i
                                        class="icofont-ui-call"></i>
                                    <p style="font-weight:700 !important;" *ngIf="language == 'en'">{{
                                        HospitalContacts?.phoneNumberEn }}</p>
                                    <p *ngIf="language == 'ar'"
                                        style="font-size: 22px !important;direction: ltr !important;">
                                        {{HospitalContacts?.phoneNumberAr }}</p>
                                </a></li> -->
                            <!-- <li class="addres">
                                <i class="icofont-location-pin"></i>
                                {{ language == 'en' ? HospitalContacts?.addressEn : HospitalContacts?.addressAr }}
                            </li> -->

                        </ul>
                    </div>
                    <div class="social-icons" style="margin: 30px 0px; color: white !important;">
                        <a [href]="HospitalContacts?.linkedIn" target="LinkedIn" style="margin: 0px 10px;">
                            <svg height="30px" width="30px" version="1.1" id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 382 382" xml:space="preserve">
                                <path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
	C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
	H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
	c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
	s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
	c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
	c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
	c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
	L341.91,330.654L341.91,330.654z" />
                            </svg>
                        </a>
                        <a [href]="HospitalContacts?.twitter" target="X" style="margin: 0px 10px ;padding: 5px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#000"
                                viewBox="0 0 16 16" class="bi bi-twitter-x">
                                <path
                                    d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                            </svg>
                        </a>
                        <a [href]="HospitalContacts?.youTube" target="YouTube" style="margin: 0px 10px ;padding: 5px;">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="#FF0000"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M23.5 6.2C23.4 5.8 23.2 5.4 22.9 5.1C22.6 4.8 22.2 4.6 21.8 4.5C20 4 12 4 12 4C12 4 4 4 2.2 4.5C1.8 4.6 1.4 4.8 1.1 5.1C0.8 5.4 0.6 5.8 0.5 6.2C0 8 0 12 0 12C0 12 0 16 0.5 17.8C0.6 18.2 0.8 18.6 1.1 18.9C1.4 19.2 1.8 19.4 2.2 19.5C4 20 12 20 12 20C12 20 20 20 21.8 19.5C22.2 19.4 22.6 19.2 22.9 18.9C23.2 18.6 23.4 18.2 23.5 17.8C24 16 24 12 24 12C24 12 24 8 23.5 6.2ZM9.75 15.5V8.5L15.5 12L9.75 15.5Z" />
                            </svg>
                        </a>
                    </div>
                </div>
                <!-- <div style="margin: 55px" class="text-center">
                    <a target="AppStore" [href]="environment.IOSAppLink">
                        <img src="assets/img/contact/AppStore.png" alt="AppStore" height="75px" width="210px" >
                    </a>
                    <a target="Android" [href]="environment.AndroidAppLink">
                        <img src="assets/img/contact/Android.png" alt="Android" height="80px" width="220px" >
                    </a>
                </div> -->
            </div>
           <div class="col-sm-6 col-lg-3">
            <div class="footer-item">
  <div class="footer-quick">
    <h3>{{ 'COMMON.QUICKLINKS' | translate }}</h3>
    <ul class="footer-dropdown-nav">
      <li class="dropdown">
        <a href="#" class="dropdown-toggle">{{'MENU.ABOUTUS' | translate}}</a>
        <ul class="dropdown-menu">
          <li><a href="/about">{{'MENU.ABOUTUSNew' | translate}}</a></li>
          <li><a href="/boards/1">{{'MENU.Board' | translate}}</a></li>
          <li><a href="/boardofdirectors/2">{{'MENU.BoardOfDirectors' | translate}}</a></li>
        </ul>
      </li>
      <li class="dropdown">
        <a href="#" class="dropdown-toggle">{{'MENU.ENTITIES' | translate}}</a>
        <ul class="dropdown-menu">
          <li><a href="/hospitals/1">{{'MENU.HOPITALS' | translate}}</a></li>
          <li><a href="/medicalcenters/2">{{'MENU.MEDICALCENTERS' | translate}}</a></li>
        </ul>
      </li>
      <!-- <li><a href="/news">{{'MENU.BLOG' | translate}}</a></li> -->
      <li><a href="/investment">{{'MENU.OFFERS' | translate}}</a></li>
      <li><a href="https://balsamvolt.com/VOLT/Public/frmAvailablePositionsList.aspx" target="_blank">{{'MENU.CAREERS' | translate}}</a></li>
      <li><a href="/contact">{{'MENU.CONTACTUS' | translate}}</a></li>
    </ul>
  </div>
</div>

            </div>

            <!-- <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-quick">
                        <h3>Our Services</h3>
                        <ul>
                            <li><a routerLink="/">Dental Care</a></li>
                            <li><a routerLink="/">Cardiology</a></li>
                            <li><a routerLink="/">Hijama Therapy</a></li>
                            <li><a routerLink="/">Massage Therapy</a></li>
                            <li><a routerLink="/">Ambluance Sevices</a></li>
                            <li><a routerLink="/">Medicine</a></li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-feedback">
                        <h3>{{'COMMON.FEEDBACK' | translate}}</h3>
                        <form>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="{{'CONTACTUS.NAME' | translate}}">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="{{'CONTACTUS.PHONE' | translate}}">
                            </div>
                            <div class="form-group">
                                <textarea class="form-control" id="your_message" rows="5"
                                    placeholder="{{'CONTACTUS.MESSAGE' | translate}}"></textarea>
                            </div>
                            <div class="text-left">
                                <button type="submit" class="btn feedback-btn">{{'CONTACTUS.SEND' | translate}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</footer>
<div class="copyright-area">
    <div class="container">
        <div class="copyright-item">
            <p style="direction: ltr !important;">Developed By <a href="http://4utechnology.org/" target="_blank"
                    style="text-decoration: underline !important;">4utechnology</a></p>
        </div>
    </div>
</div>